import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';
import urlConform from './urlConform';

import styles from './YouTube.styles';

export interface Props {
  title?: string;
  url: string;
}

function YouTube({title, url}: Props): ReactElement {

  return (
    <div className={cx(styles.container)}>
      <iframe
        className={cx(styles.iframe)}
        allow="autoplay; fullscreen; picture-in-picture"
        frameBorder="0"
        src={urlConform(url)}
        title={title}
      />
    </div>
  );
}

export default YouTube;
